import React from 'react';

interface Props{
  width:number,
  height:number,
}

const SvgTemplateDashboard = (props:Props) => (
<svg
    {...props}
    width={52}
    height={52}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#a)">
      <path
        d="M42.25 9.75H9.75a2.71 2.71 0 0 0-2.708 2.708v27.084A2.71 2.71 0 0 0 9.75 42.25h32.5a2.71 2.71 0 0 0 2.708-2.708V12.458A2.71 2.71 0 0 0 42.25 9.75Z"
        fill="#9A82DB"
      />
      <path
        d="M9.75 10.75h32.5a1.71 1.71 0 0 1 1.708 1.708v27.084a1.71 1.71 0 0 1-1.708 1.708H9.75a1.71 1.71 0 0 1-1.708-1.708V12.458A1.71 1.71 0 0 1 9.75 10.75Z"
        stroke="url(#b)"
        strokeOpacity={0.1}
        strokeWidth={2}
      />
      <g filter="url(#c)" shapeRendering="crispEdges">
        <path
          d="M40.609 39H11.39c-.606 0-1.1-.433-1.1-.97V20.367c0-.537.494-.97 1.1-.97H40.61c.606 0 1.1.433 1.1.97V38.03c0 .537-.494.97-1.1.97Z"
          fill="url(#d)"
        />
        <path
          d="M40.609 38.5H11.39c-.392 0-.6-.267-.6-.47V20.367c0-.203.208-.47.6-.47H40.61c.392 0 .6.267.6.47V38.03c0 .203-.208.47-.6.47Z"
          stroke="url(#e)"
          strokeOpacity={0.1}
          strokeLinecap="round"
        />
      </g>
      <g filter="url(#f)" shapeRendering="crispEdges">
        <path
          d="M20.616 16.147h-8.753a1.572 1.572 0 0 1 0-3.142h8.753a1.572 1.572 0 0 1 0 3.142Z"
          fill="url(#g)"
        />
        <path
          d="M20.616 15.647h-8.753a1.072 1.072 0 0 1 0-2.142h8.753a1.072 1.072 0 0 1 0 2.142Z"
          stroke="url(#h)"
          strokeOpacity={0.1}
          strokeLinecap="round"
        />
      </g>
      <g filter="url(#i)" shapeRendering="crispEdges">
        <path
          d="M26 16.142A1.57 1.57 0 1 0 26 13a1.57 1.57 0 0 0 0 3.142Z"
          fill="url(#j)"
        />
        <path
          d="M27.07 14.57a1.07 1.07 0 1 1-2.14 0 1.07 1.07 0 0 1 2.14 0Z"
          stroke="url(#k)"
          strokeOpacity={0.1}
          strokeLinecap="round"
        />
      </g>
      <rect
        x={15.167}
        y={22.209}
        width={21.667}
        height={6.5}
        rx={2}
        fill="#D0BCFF"
      />
      <g filter="url(#l)" shapeRendering="crispEdges">
        <path
          d="M33.11 24.375H18.89c-.56 0-1.015.485-1.015 1.083 0 .599.455 1.084 1.016 1.084h14.218c.561 0 1.016-.485 1.016-1.084 0-.598-.455-1.083-1.016-1.083Z"
          fill="url(#m)"
        />
        <path
          d="M18.89 24.875h14.22c.254 0 .515.23.515.583s-.26.584-.516.584H18.891c-.255 0-.516-.23-.516-.584 0-.353.26-.583.516-.583Z"
          stroke="url(#n)"
          strokeOpacity={0.1}
          strokeLinecap="round"
        />
      </g>
      <rect
        x={15.167}
        y={30.334}
        width={21.667}
        height={6.5}
        rx={2}
        fill="#D0BCFF"
      />
      <g filter="url(#o)" shapeRendering="crispEdges">
        <path
          d="M33.11 32.5H18.89c-.56 0-1.015.485-1.015 1.083 0 .599.455 1.084 1.016 1.084h14.218c.561 0 1.016-.485 1.016-1.084 0-.598-.455-1.083-1.016-1.083Z"
          fill="url(#p)"
        />
        <path
          d="M18.89 33h14.22c.254 0 .515.23.515.583s-.26.584-.516.584H18.891c-.255 0-.516-.23-.516-.584 0-.353.26-.583.516-.583Z"
          stroke="url(#q)"
          strokeOpacity={0.1}
          strokeLinecap="round"
        />
      </g>
    </g>
    <path
      d="M37.917 46.583a8.667 8.667 0 1 0 0-17.333 8.667 8.667 0 0 0 0 17.333Z"
      fill="#FD6B86"
    />
    <path
      d="M45.583 37.917a7.667 7.667 0 1 1-15.333 0 7.667 7.667 0 0 1 15.333 0Z"
      stroke="url(#r)"
      strokeOpacity={0.1}
      strokeWidth={2}
    />
    <g filter="url(#s)">
      <mask id="v" fill="#fff">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M34.93 40.412c.575 0 1.086-.198 1.533-.53.128-.131.447-.065.575.133a.483.483 0 0 1-.064.728 3.603 3.603 0 0 1-2.044.662 3.465 3.465 0 0 1-2.491-1.059 3.722 3.722 0 0 1-1.022-2.581c0-.993.383-1.92 1.022-2.581a3.465 3.465 0 0 1 2.49-1.059c.96 0 1.853.397 2.428 1.059l2.236 2.316a.533.533 0 0 1 0 .728.479.479 0 0 1-.32.133.48.48 0 0 1-.319-.133l-2.236-2.316c-.447-.53-1.085-.794-1.788-.794-.639 0-1.278.33-1.789.794-.51.463-.766 1.125-.766 1.853s.32 1.324.766 1.853c.448.53 1.086.794 1.789.794Zm6-6.287c.951 0 1.839.397 2.472 1.059a3.738 3.738 0 0 1 1.015 2.581c0 .993-.38 1.92-1.015 2.581a3.426 3.426 0 0 1-2.472 1.059c-.95 0-1.838-.397-2.472-1.059l-2.219-2.316a.536.536 0 0 1 0-.728.483.483 0 0 1 .698 0l2.218 2.316c.444.53 1.078.794 1.775.794.697 0 1.268-.33 1.775-.794.507-.463.76-1.125.76-1.853s-.253-1.39-.697-1.92c-.443-.529-1.077-.794-1.774-.794-.57 0-1.078.2-1.522.53a.473.473 0 0 1-.634-.066.485.485 0 0 1 .064-.728 3.557 3.557 0 0 1 2.028-.662Z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.93 40.412c.575 0 1.086-.198 1.533-.53.128-.131.447-.065.575.133a.483.483 0 0 1-.064.728 3.603 3.603 0 0 1-2.044.662 3.465 3.465 0 0 1-2.491-1.059 3.722 3.722 0 0 1-1.022-2.581c0-.993.383-1.92 1.022-2.581a3.465 3.465 0 0 1 2.49-1.059c.96 0 1.853.397 2.428 1.059l2.236 2.316a.533.533 0 0 1 0 .728.479.479 0 0 1-.32.133.48.48 0 0 1-.319-.133l-2.236-2.316c-.447-.53-1.085-.794-1.788-.794-.639 0-1.278.33-1.789.794-.51.463-.766 1.125-.766 1.853s.32 1.324.766 1.853c.448.53 1.086.794 1.789.794Zm6-6.287c.951 0 1.839.397 2.472 1.059a3.738 3.738 0 0 1 1.015 2.581c0 .993-.38 1.92-1.015 2.581a3.426 3.426 0 0 1-2.472 1.059c-.95 0-1.838-.397-2.472-1.059l-2.219-2.316a.536.536 0 0 1 0-.728.483.483 0 0 1 .698 0l2.218 2.316c.444.53 1.078.794 1.775.794.697 0 1.268-.33 1.775-.794.507-.463.76-1.125.76-1.853s-.253-1.39-.697-1.92c-.443-.529-1.077-.794-1.774-.794-.57 0-1.078.2-1.522.53a.473.473 0 0 1-.634-.066.485.485 0 0 1 .064-.728 3.557 3.557 0 0 1 2.028-.662Z"
        fill="url(#t)"
        shapeRendering="crispEdges"
      />
      <path
        d="m36.463 39.883.595.804.067-.05.057-.06-.719-.694Zm.575.132-.841.541.053.083.068.07.72-.694Zm-.064.728.568.823.023-.016.023-.017-.614-.79Zm-4.535-.397.72-.694-.72.694Zm0-5.162-.72-.695.72.695Zm4.918 0-.755.656.018.02.018.018.72-.694Zm2.236 2.316.72-.694-.72.694Zm0 .728.72.695-.72-.695Zm-.639 0-.72.695.72-.695Zm-2.236-2.316-.764.645.022.026.023.023.72-.694Zm-3.577 0 .672.74-.672-.74Zm0 3.706.764-.645-.764.645Zm10.261-4.434-.722.692.722-.692Zm0 5.162-.722-.692.722.692Zm-4.944 0-.722.692.722-.692Zm-2.219-2.316.723-.692-.723.692Zm0-.728.723.691-.723-.691Zm.698 0 .722-.692-.722.692Zm2.218 2.316.767-.642-.022-.026-.023-.024-.722.692Zm.317-4.037.572.82.013-.009.013-.01-.598-.801Zm-.634-.066-.722.691.722-.691Zm.064-.728-.572-.82-.023.015-.022.017.617.788Zm-3.034 4.292c-.303.224-.61.333-.938.333v2c.82 0 1.536-.287 2.128-.725l-1.19-1.608Zm2.01.395a1.463 1.463 0 0 0-.91-.625c-.276-.061-.816-.084-1.225.34l1.44 1.388a.772.772 0 0 1-.41.226.538.538 0 0 1-.575-.246l1.68-1.083Zm-.29 2.059a1.483 1.483 0 0 0 .17-2.212l-1.44 1.389a.518.518 0 0 1 .042-.756l1.228 1.579Zm-2.658.872c1 0 1.898-.346 2.612-.839l-1.136-1.646c-.436.301-.944.485-1.476.485v2Zm-3.21-1.364a4.465 4.465 0 0 0 3.21 1.364v-2c-.68 0-1.317-.282-1.772-.753L31.72 41.04Zm-1.303-3.276c0 1.248.48 2.425 1.302 3.276l1.44-1.39a2.723 2.723 0 0 1-.742-1.886h-2Zm1.302-3.276a4.722 4.722 0 0 0-1.302 3.276h2c0-.738.285-1.414.741-1.887L31.72 34.49Zm3.21-1.364a4.465 4.465 0 0 0-3.21 1.364l1.44 1.39a2.465 2.465 0 0 1 1.77-.754v-2Zm3.183 1.403c-.779-.896-1.956-1.403-3.182-1.403v2c.69 0 1.301.288 1.672.715l1.51-1.312Zm2.2 2.278-2.235-2.317-1.44 1.39 2.236 2.316 1.44-1.39Zm0 2.117a1.533 1.533 0 0 0 0-2.117l-1.439 1.389a.477.477 0 0 1-.136-.33c0-.105.037-.228.136-.331l1.44 1.389Zm-1.038.438c.422 0 .803-.194 1.038-.438l-1.439-1.39a.564.564 0 0 1 .178-.128.543.543 0 0 1 .223-.044v2Zm-1.04-.438c.236.244.617.438 1.04.438v-2c.102 0 .177.025.222.044.04.018.105.054.178.129l-1.44 1.389ZM36 36.606l2.236 2.317 1.439-1.39-2.236-2.316-1.439 1.39Zm-1.07-.488c.444 0 .79.16 1.026.44l1.528-1.291c-.66-.78-1.591-1.15-2.553-1.15v2Zm-1.116.535c.403-.365.812-.535 1.117-.535v-2c-.973 0-1.84.491-2.46 1.053l1.343 1.482Zm-.438 1.112c0-.493.169-.868.438-1.112L32.47 35.17c-.753.682-1.095 1.63-1.095 2.594h2Zm.53 1.208c-.361-.428-.53-.802-.53-1.208h-2c0 1.05.47 1.867 1.002 2.498l1.528-1.29Zm1.025.44c-.444 0-.79-.161-1.025-.44l-1.528 1.29c.66.78 1.591 1.15 2.553 1.15v-2Zm9.195-4.92a4.426 4.426 0 0 0-3.195-1.368v2c.67 0 1.3.28 1.75.75l1.445-1.383Zm1.292 3.272a4.737 4.737 0 0 0-1.292-3.273l-1.445 1.384c.452.472.737 1.149.737 1.889h2Zm-1.292 3.273a4.737 4.737 0 0 0 1.292-3.273h-2c0 .74-.285 1.417-.737 1.89l1.445 1.383Zm-3.195 1.367a4.426 4.426 0 0 0 3.195-1.367l-1.445-1.384c-.45.471-1.08.751-1.75.751v2Zm-3.194-1.367a4.426 4.426 0 0 0 3.194 1.367v-2c-.67 0-1.3-.28-1.75-.75l-1.444 1.383Zm-2.219-2.317 2.219 2.317 1.444-1.384-2.218-2.316-1.445 1.383Zm0-2.111a1.536 1.536 0 0 0 0 2.111l1.444-1.383a.475.475 0 0 1 .136.328.475.475 0 0 1-.136.327l-1.444-1.383Zm2.142 0a1.483 1.483 0 0 0-2.142 0l1.444 1.383a.517.517 0 0 1-.747 0l1.445-1.383Zm2.218 2.316L37.66 36.61l-1.445 1.383 2.22 2.317 1.443-1.384Zm1.053.486c-.435 0-.775-.158-1.008-.436l-1.533 1.284c.654.781 1.582 1.152 2.541 1.152v-2Zm1.1-.532c-.412.376-.751.532-1.1.532v2c1.046 0 1.848-.506 2.45-1.056l-1.35-1.476Zm.436-1.115c0 .495-.169.871-.435 1.115l1.349 1.476c.747-.683 1.086-1.63 1.086-2.591h-2Zm-.464-1.277c.297.354.464.79.464 1.277h2c0-.969-.34-1.857-.931-2.562l-1.533 1.285Zm-1.008-.437c.435 0 .775.159 1.008.437l1.533-1.285c-.654-.78-1.582-1.152-2.541-1.152v2Zm-.924.332c.3-.224.601-.332.924-.332v-2c-.82 0-1.531.29-2.12.728l1.196 1.604Zm-1.954-.177c.56.586 1.37.584 1.928.196L38.9 34.76a.51.51 0 0 1 .329-.085c.148.01.264.079.33.148l-1.444 1.383Zm.17-2.207a1.485 1.485 0 0 0-.17 2.207l1.444-1.383a.515.515 0 0 1-.042.751L38.285 34Zm2.644-.874c-.996 0-1.89.347-2.6.841l1.143 1.642c.431-.3.933-.483 1.457-.483v-2Z"
        fill="url(#u)"
        fillOpacity={0.1}
        mask="url(#v)"
      />
    </g>
    <defs>
      <linearGradient
        id="b"
        x1={26}
        y1={9.75}
        x2={26}
        y2={42.25}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="d"
        x1={26}
        y1={19.397}
        x2={26}
        y2={39}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity={0.9} />
        <stop offset={1} stopColor="#fff" stopOpacity={0.8} />
      </linearGradient>
      <linearGradient
        id="e"
        x1={26}
        y1={19.397}
        x2={26}
        y2={39}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="g"
        x1={16.239}
        y1={13.005}
        x2={16.239}
        y2={16.147}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity={0.9} />
        <stop offset={1} stopColor="#fff" stopOpacity={0.8} />
      </linearGradient>
      <linearGradient
        id="h"
        x1={16.239}
        y1={13.005}
        x2={16.239}
        y2={16.147}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="j"
        x1={26}
        y1={13}
        x2={26}
        y2={16.142}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity={0.9} />
        <stop offset={1} stopColor="#fff" stopOpacity={0.8} />
      </linearGradient>
      <linearGradient
        id="k"
        x1={26}
        y1={13}
        x2={26}
        y2={16.142}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="m"
        x1={26}
        y1={24.375}
        x2={26}
        y2={26.542}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity={0.9} />
        <stop offset={1} stopColor="#fff" stopOpacity={0.8} />
      </linearGradient>
      <linearGradient
        id="n"
        x1={26}
        y1={24.375}
        x2={26}
        y2={26.542}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="p"
        x1={26}
        y1={32.5}
        x2={26}
        y2={34.667}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity={0.9} />
        <stop offset={1} stopColor="#fff" stopOpacity={0.8} />
      </linearGradient>
      <linearGradient
        id="q"
        x1={26}
        y1={32.5}
        x2={26}
        y2={34.667}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="r"
        x1={37.917}
        y1={29.25}
        x2={37.917}
        y2={46.583}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="t"
        x1={37.917}
        y1={34.125}
        x2={37.917}
        y2={41.405}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity={0.9} />
        <stop offset={1} stopColor="#fff" stopOpacity={0.8} />
      </linearGradient>
      <linearGradient
        id="u"
        x1={37.917}
        y1={34.125}
        x2={37.917}
        y2={41.405}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
      <filter
        id="c"
        x={10.292}
        y={19.397}
        width={31.417}
        height={20.603}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1945_2225"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_1945_2225"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1} />
        <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
        <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0" />
        <feBlend in2="shape" result="effect2_innerShadow_1945_2225" />
      </filter>
      <filter
        id="f"
        x={10.292}
        y={13.005}
        width={11.895}
        height={4.142}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1945_2225"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_1945_2225"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1} />
        <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
        <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0" />
        <feBlend in2="shape" result="effect2_innerShadow_1945_2225" />
      </filter>
      <filter
        id="i"
        x={24.429}
        y={13}
        width={3.142}
        height={4.142}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1945_2225"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_1945_2225"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1} />
        <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
        <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0" />
        <feBlend in2="shape" result="effect2_innerShadow_1945_2225" />
      </filter>
      <filter
        id="l"
        x={17.875}
        y={24.375}
        width={16.25}
        height={3.167}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1945_2225"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_1945_2225"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1} />
        <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
        <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0" />
        <feBlend in2="shape" result="effect2_innerShadow_1945_2225" />
      </filter>
      <filter
        id="o"
        x={17.875}
        y={32.5}
        width={16.25}
        height={3.167}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1945_2225"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_1945_2225"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1} />
        <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
        <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0" />
        <feBlend in2="shape" result="effect2_innerShadow_1945_2225" />
      </filter>
      <filter
        id="s"
        x={31.417}
        y={34.125}
        width={13}
        height={8.28}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1945_2225"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_1945_2225"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1} />
        <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
        <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0" />
        <feBlend in2="shape" result="effect2_innerShadow_1945_2225" />
      </filter>
      <clipPath id="a">
        <path
          fill="#fff"
          transform="translate(7.042 9.75)"
          d="M0 0h37.917v32.5H0z"
        />
      </clipPath>
    </defs>
  </svg>
)

export default SvgTemplateDashboard;
